import React, { ReactNode } from "react";

import { Box, Preloader, Spinner } from "@origin-digital/ods-core";

export interface ILoaderProps {
  variant?: "page" | "section";
  isLoading?: boolean;
  children?: ReactNode;
}

export const Loader: React.FC<ILoaderProps> = ({
  variant = "section",
  isLoading = false,
  children,
}) => {
  if (isLoading) {
    if (variant === "page") {
      return (
        <Box
          data-id="page-loading-indicator"
          display="flex"
          justifyContent="center"
          alignItems="center"
          paddingY="xxxlarge"
        >
          <Preloader />
        </Box>
      );
    }

    return (
      <Box
        data-id="loading-indicator"
        display="flex"
        justifyContent="center"
        alignItems="center"
        paddingY={["large", "xlarge"]}
      >
        <Spinner size="small" />
      </Box>
    );
  }

  return <>{children}</>;
};
